import defaultSound from "../../assets/audio/notifications/notification.mp3";
import playfulSound from "../../assets/audio/notifications/playful.mp3";
import pointSound from "../../assets/audio/notifications/point.mp3";
import joyousSound from "../../assets/audio/notifications/joyous.mp3";
import twinkleSound from "../../assets/audio/notifications/twinkle.wav";

export interface NotificationSoundDef {
    id: string;
    label: string;
    src: string;
}

export const NOTIFICATION_SOUNDS: NotificationSoundDef[] = [
    {id: "default", label: "Default", src: defaultSound},
    {id: "playful", label: "Playful", src: playfulSound},
    {id: "point", label: "To The Point", src: pointSound},
    {id: "joyous", label: "Joyous", src: joyousSound},
    {id: "twinkle", label: "Twinkle", src: twinkleSound},
];

export const DEFAULT_SOUND_ID = NOTIFICATION_SOUNDS[0].id;

export const getSoundById = (id: string): NotificationSoundDef =>
    NOTIFICATION_SOUNDS.find((s) => s.id === id) ?? NOTIFICATION_SOUNDS[0];